import React, {useEffect, useState} from "react";
import {ResultCardList} from "./ResultCardList";
import {CardsWrapper} from "./ResultCardList.styles";

export const ResultCardsList = ({markersData, margin, DirectionsLinkText, UseNewCardStyle}) => {
    const [manipulatedData, setManipulatedData] = useState([]);
    const addLettersAndSort = () => {
        markersData = markersData.filter(c => c !== undefined && c !== '');
        if (!markersData?.length) {
            return;
        }

        let letterArray = [];
        markersData.map(({SortingName}) => {
            let firstLetter = SortingName.charAt(0);
            let objToAdd = {SortingName: firstLetter};
            if (!letterArray.some((letter) => letter.SortingName === firstLetter)) {
                letterArray.push(objToAdd);
            }
        });
        let sortedArray = letterArray.concat(markersData).sort((a, b) => {
            return a.SortingName.localeCompare(b.SortingName);
        });
        setManipulatedData(sortedArray);
    };

    useEffect(() => {
        addLettersAndSort();
    }, [markersData]);

    return (
        <CardsWrapper smallmargin="0" margin="0 0 0 -1rem" smallrow flexwrap="wrap">
            {manipulatedData?.length > 0 && manipulatedData?.map((marker, key) => (
                <ResultCardList
                    marker={marker}
                    DirectionsLinkText={DirectionsLinkText}
                    key={`ResultCard-${key}`}
                />
            ))}
        </CardsWrapper>
    );
};
